import { render, staticRenderFns } from "./order_config.vue?vue&type=template&id=5723ef36&scoped=true&"
import script from "./order_config.vue?vue&type=script&lang=js&"
export * from "./order_config.vue?vue&type=script&lang=js&"
import style0 from "./order_config.vue?vue&type=style&index=0&id=5723ef36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5723ef36",
  null
  
)

export default component.exports